import orderBy from 'lodash/orderBy';
import values from 'lodash/values';
import PropTypes from 'prop-types';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { Icon, Image, Label, List } from 'semantic-ui-react';

import { UserFlag } from '../../components/Avatars/UserFlag';
import { useScreenConfig } from '../../config/screens.context';
import { avatarWithFallbackWhenMissing } from '../../utils/avatarUtils';
import { fromNow } from '../../utils/dateUtils';
import { getUserUnreadCount } from '../store/networking.helpers';
import './ChatList.scss';

const ChatList = ({ chats, me }) => {
  const { displayCustomFields } = useScreenConfig('networking');
  const validFields = (displayCustomFields || []).filter((field) => field.type !== 'tag');
  const contactList = orderBy(
    values(chats).map((chat) => ({ ...chat, updatedAt: chat.updatedAt || chat.createdAt })),
    'updatedAt',
    'desc',
  );
  const imageSize = 50;

  return (
    <List divided verticalAlign="middle" relaxed selection className="item--table">
      {contactList.map((chat) => {
        const profile = (me === chat.inviter ? chat.invitedProfile : chat.inviterProfile) || {};
        const name = `${profile.firstName} ${profile.lastName}`;
        const unreadCount = getUserUnreadCount(chat);
        return (
          <List.Item
            key={`chat-preview-${chat.id}`}
            className="item--table"
            as={NavLink}
            to={`/networking/chats/${chat.hash}`}
            aria-label={name}
            tabIndex={0}
          >
            <div className="image-container" style={{ width: imageSize }}>
              <Image
                avatar
                style={{ width: imageSize, height: imageSize }}
                src={avatarWithFallbackWhenMissing(profile.thumbnail, imageSize)}
                alt={`${name}'s avatar`}
              />
              <UserFlag user={profile} />
            </div>
            <List.Content>
              {!!unreadCount && (
                <Label color="blue" className="unread">
                  {unreadCount}
                </Label>
              )}
              <div className="hour">{fromNow(chat.updatedAt)}</div>
              <List.Header>{name}</List.Header>
              <List.Description>
                {validFields
                  .filter((field) => profile[field.field])
                  .map((field) => (
                    <div key={field.field}>
                      {field.icon && <Icon name={field.icon} />}&nbsp;{profile[field.field]}
                    </div>
                  ))}
              </List.Description>
            </List.Content>
          </List.Item>
        );
      })}
    </List>
  );
};

ChatList.defaultProps = {};

ChatList.propTypes = {
  chats: PropTypes.object.isRequired,
  me: PropTypes.string.isRequired,
};
export default ChatList;
